/**
 * @author vishwadeep.kapoor
 * @Date: 2018-12-31 13:23:53
 * @Last Modified by: salla.saishiva
 * @Last Modified time: 2024-02-07 13:35:18
 */
import React, { PureComponent } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { Box } from 'grid-styled';
import { withRouter } from 'react-router-dom';
import { func, shape, bool, object } from 'prop-types';

import { Row, Col } from 'antd';
import Container from '../Container';
import FooterSegment from '../FooterSegment';
import { selectUserDetails } from '../../containers/HeaderContainer/selectors';
import { constants, utils, validations } from '../../devUtils';
import endPoints from '../../config/endPoints';
import { setFooterSubscribe, rootApiResponse, clearDefaultError } from '../../containers/HeaderContainer/actions';
import { MANIPAL_FOOTER_DESC } from './constants';
import StyledClientLogin from '../../containers/ClientLogin/styledClientLogin';
import FooterNew from '../FooterNew';


const ManipalSecondaryDescription = () => (
  <Row type="flex" align="middle" justify="center">
    <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
      <ul className="footer-links-manipalcigna">
        <li><a href={constants.LINK_MANIPAL_ABOUTUS}>About Us</a></li>
        <li><a href={constants.MANIPAL_CIGNA_HOME} target="_blank">The Tree of Life Collection</a></li>
        <li><a href={constants.LINK_MANIPAL_REFUN_RETURN_POLICY} target="_blank">Return &amp; Refund Policy</a></li>
        <li><a href={constants.LINK_CONTACTUS} target="_blank">Contact Us</a></li>
      </ul>
    </Col>
    <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
      <div dangerouslySetInnerHTML={{ __html: MANIPAL_FOOTER_DESC }} />
    </Col>
  </Row>
);

class Footer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };
    this.onSubscribeSubmit = this.onSubscribeSubmit.bind(this);
  }

  onSubscribeSubmit() {
    const { email } = this.state;
    const { onSetFooterSubscribe, onTriggerAlert, onClearError } = this.props;
    const payload = {
      email,
      source: 'news_subscription',
    };
    const _validators = utils.updateValidators(validations, 'email', email);
    const isError = _validators.email && _validators.email.errors.length;
    if (email && !isError) {
      onSetFooterSubscribe(payload);
      this.setState({ email: '' });
    } else {
      onClearError();
      setTimeout(() => onTriggerAlert(utils.errorResponse('setFooterSubscribe', 'Please enter valid email address')), 250);
    }
  }

  handleSubscribeChange(value) {
    this.setState({ email: value });
  }

  renderClientFooter(isOnlyMerchandise, pathname) {
    if (isOnlyMerchandise || [constants.LINK_CLIENT_MANIPAL, constants.LINK_MANIPAL_ABOUTUS, constants.LINK_MANIPAL_REFUN_RETURN_POLICY].includes(pathname)) {
      return (
        <StyledClientLogin>
          <section className="mid-layer">
            <Container>
              <ManipalSecondaryDescription />
            </Container>
          </section>
          <footer>
            <Container>
              <Box width={[12 / 12, 12 / 12]} className="text-center padding-tb-2">
                Brought to you by <img src={endPoints.ZAGGLE_LOGO.URL} alt={endPoints.ZAGGLE_LOGO.ALT} />
              </Box>
            </Container>
          </footer>
        </StyledClientLogin>);
    }
    return null;
  }

  render() {
    const {
      GetUserDetails: {
        isOnlyMerchandise = false,
        client_series = '',
      },
      history: {
        location: {
          pathname = '',
        } = {},
      } = {},
    } = this.props;
    return (
      <div>
        {((!isOnlyMerchandise && ![constants.LINK_CLIENT_MANIPAL, constants.LINK_MANIPAL_ABOUTUS, constants.LINK_MANIPAL_REFUN_RETURN_POLICY].includes(pathname)) || (client_series === endPoints.PROPEL_CORPORATE_GIFTING)) ?
          <FooterNew /> :
          <FooterSegment>
            {this.renderClientFooter(isOnlyMerchandise, pathname)}
          </FooterSegment>
        }
      </div>

    );
  }
}

Footer.propTypes = {
  history: object.isRequired,
  onSetFooterSubscribe: func.isRequired,
  onTriggerAlert: func.isRequired,
  onClearError: func.isRequired,
  GetUserDetails: shape({
    isOnlyMerchandise: bool,
  }).isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  onSetFooterSubscribe: (payload) => dispatch(setFooterSubscribe(payload)),
  onTriggerAlert: (payload) => dispatch(rootApiResponse(payload)),
  onClearError: () => dispatch(clearDefaultError({})),
});

const mapStateToProps = createStructuredSelector({
  GetUserDetails: selectUserDetails(),
});

const component = connect(mapStateToProps, mapDispatchToProps)(withRouter(Footer));
export { Footer, mapStateToProps, mapDispatchToProps, ManipalSecondaryDescription };
export default component;



// WEBPACK FOOTER //
// client/components/Footer/index.js